import { render, staticRenderFns } from "./FieldsetContractClientData.yaml?vue&type=template&id=2d8ce1f4&component"
import script from "./FieldsetContractClientData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractClientData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports